import React, { useState } from 'react';
import { Mail, Send } from 'lucide-react';
export const ContactUs = () => {
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    await new Promise(resolve => setTimeout(resolve, 1000));
    setSubmitted(true);
    setLoading(false);
  };
  return <div className="py-24 bg-white" data-id="element-124">
      <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-125">
        <div className="text-center mb-16" data-id="element-126">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#6366f1]/10 rounded-2xl mb-6" data-id="element-127">
            <Mail className="h-8 w-8 text-[#6366f1]" data-id="element-128" />
          </div>
          <h1 className="text-4xl font-bold text-gray-900 mb-4" data-id="element-129">
            Get in Touch
          </h1>
          <p className="text-xl text-gray-600" data-id="element-130">
            Questions? Feedback? We'd love to hear from you.
          </p>
        </div>
        {!submitted ? <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-8" data-id="element-131">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-132">
              <div data-id="element-133">
                <label htmlFor="name" className="block text-sm font-semibold text-gray-900 mb-2" data-id="element-134">
                  Name
                </label>
                <input type="text" id="name" required value={formState.name} onChange={e => setFormState(prev => ({
              ...prev,
              name: e.target.value
            }))} className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#6366f1] focus:border-transparent outline-none transition-all" placeholder="Your name" data-id="element-135" />
              </div>
              <div data-id="element-136">
                <label htmlFor="email" className="block text-sm font-semibold text-gray-900 mb-2" data-id="element-137">
                  Email
                </label>
                <input type="email" id="email" required value={formState.email} onChange={e => setFormState(prev => ({
              ...prev,
              email: e.target.value
            }))} className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#6366f1] focus:border-transparent outline-none transition-all" placeholder="your@email.com" data-id="element-138" />
              </div>
              <div data-id="element-139">
                <label htmlFor="message" className="block text-sm font-semibold text-gray-900 mb-2" data-id="element-140">
                  Message
                </label>
                <textarea id="message" required value={formState.message} onChange={e => setFormState(prev => ({
              ...prev,
              message: e.target.value
            }))} className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#6366f1] focus:border-transparent outline-none transition-all min-h-[150px] resize-none" placeholder="What's on your mind?" data-id="element-141" />
              </div>
              <button type="submit" disabled={loading} className="w-full py-4 bg-[#d5ff00] text-gray-900 rounded-xl hover:bg-[#c0e600] font-semibold transition-all disabled:opacity-70 disabled:cursor-not-allowed flex items-center justify-center gap-2 shadow-sm" data-id="element-142">
                {loading ? 'Sending...' : <>
                    <Send size={20} data-id="element-143" />
                    Send Message
                  </>}
              </button>
            </form>
          </div> : <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-12 text-center" data-id="element-144">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-green-100 rounded-full mb-6" data-id="element-145">
              <div className="text-3xl" data-id="element-146">🎉</div>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-147">
              Message Sent!
            </h2>
            <p className="text-gray-600" data-id="element-148">
              Thanks for reaching out! We'll get back to you as soon as
              possible.
            </p>
          </div>}
      </div>
    </div>;
};